import { DirectiveOptions } from 'vue';

const preloader: DirectiveOptions = {
    bind(el, { value }): void {
        el.classList.add('has-preloader');
        el.classList.toggle('is-loading', value === true);
    },
    update(el, { value, oldValue }) {
        if (value === oldValue) {
            return;
        }
        el.classList.toggle('is-loading', value === true);
    },
    unbind(el): void {
        el.classList.remove('is-loading');
        el.classList.remove('has-preloader');
    },
};

export default preloader;



// WEBPACK FOOTER //
// ./src/directives/preloader.ts